import { useParams } from "react-router";
import { ApiPatient } from "../../../core/apis/patient";
import { ProfileCard } from "../../../features/patient/profile/profileCard.component";
import { ProfileNav } from "../../../components/profileNav.component";
import { PersonalInformation } from "../../../features/patient/profile/personalInformation";
import { useState } from "react";
import { PatientCaregiverList } from "../../../features/patient/profile/patientCaregiverList.component";
import { ComingSoon } from "../../../components/comingSoon.component";
import { PatientActivityLogCard } from "../../../features/patient/profile/activityLogCard.component";
import { UtilityDate } from "../../../utils/dateUtils";
import { addDays } from "date-fns/esm";

export const PageSinglePatient = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { data, isValidating } = ApiPatient.ById.Hook(patientId);
  const [selectedPage, setSelectedPage] = useState("Personal Information");

  const pages: { [key: string]: string | JSX.Element } = {
    "Personal Information": (
      <PersonalInformation data={data} isValidating={isValidating} />
    ),
    "Care Giver List": (
      <PatientCaregiverList data={data} isValidating={isValidating} />
    ),
    "Activity Log": (
      <PatientActivityLogCard data={data} isValidating={isValidating} />
    ),
    "Financial Log": <ComingSoon />,
  };

  return (
    <>
      {!isValidating &&
        new Date(data?.serviceAuthorizationEndDate!) <
          addDays(new Date(), 7) && (
          <div className="alert alert-danger text-capitalize" role="alert">
            This Service Authorization
            {new Date(data?.serviceAuthorizationEndDate!) < new Date()
              ? " was expired "
              : " will expire "}
            on {UtilityDate.formatDate(data?.serviceAuthorizationEndDate)}
          </div>
        )}

      <ProfileCard data={data} isValidating={isValidating} />

      <ProfileNav
        items={[
          "Personal Information",
          "Care Giver List",
          "Activity Log",
          // "Financial Log",
        ]}
        active={selectedPage}
        onSelect={setSelectedPage}
      />

      {pages[selectedPage]}
    </>
  );
};
